//Import Libraries
import React, { useEffect, useState, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { updateAlert, updateAdminInputs } from "../../../../../redux/actions";
import { config } from "../../../../../config/config";
import AdminView from "../../AdminView";
import { useUserAuthentication } from "../../../../../utils/utils";
import Loader from "../../../../../components/Loader/Loader";
import { UsecaseEditView } from "./UsecaseEditView";
import { useHistory } from "react-router-dom";
import MetaSearchFilter from "./MetaSearchFilter";

let api = config.api.api_url;

function SilverTemplateMappingView(props) {
  const { user, admin_data, updateAlert, updateAdminInputs } = props || {};
  let history = useHistory();
  const URL = history?.location?.pathname;
  const Use_Case_Name = URL.split("/").pop();
  const { login } = useUserAuthentication();
  const [loading, setLoading] = useState(false);
  const [metadataLoading, setMetadataLoading] = useState(false);

  const fetchMetadata = async () => {
    setLoading(true);

    try {
      const params = new URLSearchParams({
        usecase_name: Use_Case_Name || "",
      });
      const response = await fetch(api + `/admin/getdatasets?${params}`, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
          Authorization: `Bearer ${user.token || ""}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });

          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }
      const DATASETS =
        data?.data?.datasets?.map((dataset) => {
          return { label: dataset, value: dataset };
        }) ?? [];
      updateAdminInputs("documents_list", DATASETS);
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "success",
        closeFlag: true,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMetadata();
  }, []);

  return (
    <AdminView>
      {loading ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          <Loader />
        </div>
      ) : (
        <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
          <MetaSearchFilter
            loading={loading}
            metadataLoading={metadataLoading}
            setMetadataLoading={setMetadataLoading}
          />
          {metadataLoading && (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              Loading metadata...
              <Loader />
            </div>
          )}
        </div>
      )}

      {/* CONTENT */}
      {!loading && !metadataLoading && admin_data.current_document !== "" && (
        <div
          style={{
            padding: "20px 10px",
            paddingRight: "0px",
          }}
        >
          {!loading &&
            Object.keys(admin_data?.usecase_metadata)?.length > 0 && (
              <UsecaseEditView
                adminMetadata={admin_data?.admin_metadata}
                initialData={admin_data?.usecase_metadata}
                admin_data={admin_data}
                updateAlert={updateAlert}
                updateAdminInputs={updateAdminInputs}
                user={user}
              />
            )}
        </div>
      )}
    </AdminView>
  );
}

SilverTemplateMappingView.propTypes = {
  user: PropTypes.object,
  userData: PropTypes.object,
  admin: PropTypes.object,
  updateAlert: PropTypes.func,
  updateAdminInputs: PropTypes.func,
};

const mapStateToProps = (state) => ({
  user: state.user,
  // userData:state.cncStateData.user,
  cncData: state.cncinputs,
  admin_data: state.admin,
});

const mapDispatchToProps = {
  updateAlert,
  updateAdminInputs,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SilverTemplateMappingView),
);
